/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffEditRolesCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimeStaffEditRolesCtrl', ["$filter", "$scope", "userinfo", function($filter, $scope, userinfo) {
  /**
   * Add a new role line to the staff record.
   */
  $scope.addRole = function() {
    var activeRoles = {};
    angular.forEach($scope.staff.memberRoles, function(memberRole) {
      activeRoles[memberRole.roleId] = true;
    });

    var unusedRoles = $filter('filter')($scope.roles, function(role) {
      return !activeRoles[role.id];
    });

    $scope.staff.memberRoles.push({
      hourlyRate: 0,
      roleId: unusedRoles[0].id
    });
  };

  var tempRoles = {};

  $scope.remunerationTypes = [
    {value: 'HourlyRate', label: 'Hourly Rate'},
    {value: 'Salary', label: 'Salary'}
  ];

  $scope.salaryPermission = userinfo.companyHasPermission('Salary');

  /**
   * Callback for when the default role is changed.
   */
  $scope.changeDefaultRole = function(newDefaultId) {
    angular.forEach($scope.staff.memberRoles, function(staffRole) {
      staffRole.defaultRole = (staffRole.staffRoleId == newDefaultId);
    });
  };

  /**
   * Remove a role line from the staff record
   */
  $scope.deleteRole = function(index) {
    $scope.staff.memberRoles.splice(index, 1);
  };

  /**
   * Filters the role select so already assigned roles cannot be assigned again.
   * Also, if the selected role has been deleted, display it as an option in the select box.
   */
  $scope.memberRoleOptions = function(memberRole) {
    var activeRoles = {};
    angular.forEach($scope.staff.memberRoles, function(memberRole) {
      activeRoles[memberRole.roleId] = true;
    });

    var selectableRoles = $filter('filter')($scope.roles, function(role) {
      return !activeRoles[role.id] || role.id === memberRole.roleId;
    });

    //The selected role wasn't found in the roles list so append it as an option.
    if ($filter('filter')(selectableRoles, {id: memberRole.roleId}).length === 0) {
      // Store the temp roles in an outside object. If we just create the object get an infinite digest error from Angular.
      if (!tempRoles[memberRole.roleId]) {
        tempRoles[memberRole.roleId] = {id: memberRole.roleId, name: memberRole.roleName};
      }
      selectableRoles.push(tempRoles[memberRole.roleId]);
    }
    return selectableRoles;
  };

  $scope.updateRole = function(newRoleId, previousRoleId) {
    if ($scope.staff.defaultRoleId == previousRoleId || (previousRoleId === '' && !$scope.staff.defaultRoleId)) {
      $scope.staff.defaultRoleId = newRoleId;
    }
  };

  $scope.remunerationChanged = function() {
    // If the remuneration changes, we want it to take effect from the following week.
    $scope.staff.activeRemuneration.validFrom = moment().mStartOf('week').add(1, 'week').format();
  };
}]);
